module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAADCAYAAAD7qa0WAAAABHNCSVQICAgIfAhkiAAAAFhJREFUGFe9zkENgDAQRNG/CkDCkhRfOAAJxUGRUF00oVWyHEhTFOzc5vSf3GgU2EFm3GZXoB49NwxkKSzm5hihFni035+hSUETyAZMXjDDzpUaB+gzGJZe3QQY6HHnBmQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/update/nav_hover_first.png
// module id = 1189
// module chunks = 41